<template>
  <div class="logo">
    <svg
      id="icons"
      style="width: 50%; overflow: visible"
      version="1.1"
      viewBox="0 0 2068.1 512"
      x="0px"
      xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg"
      y="0px">
      <path
        class="st0"
        d="M256,184c-50.6,0-94.2,29.4-115,72c20.8,42.6,64.4,72.1,115,72.1s94.2-29.4,115-72.1
	C350.2,213.4,306.6,184,256,184z" />
      <path
        class="st1"
        d="M176,117.4L176,117.4c-47.8,27.7-80,79.4-80,138.6c0,29.1,7.8,56.5,21.5,80h-0.1l-76.2,44
	C20.1,343.5,8,301.2,8,256C8,164.2,57.8,84.1,132,41.2v0.1L176,117.4z" />
      <path
        class="st6"
        d="M336,394.6l44,76.2c-36.5,21.1-78.8,33.2-124,33.2c-91.8,0-171.9-49.8-214.8-124l76.2-44h0.1
	c27.6,47.8,79.3,80,138.5,80C285.1,416,312.4,408.2,336,394.6L336,394.6z" />
      <path
        class="st2"
        d="M256,216c22.1,0,40,17.9,40,40c0,22.2-17.9,40.1-40,40.1s-40-17.9-40-40.1C216,233.9,233.9,216,256,216z" />
      <path
        class="st3"
        d="M416,256h88c0,45.2-12.1,87.5-33.2,124l-76.2-44h-0.1C408.2,312.5,416,285.1,416,256z" />
      <path
        class="st4"
        d="M394.6,336l76.2,44c-21.8,37.7-53.1,69-90.8,90.8l-44-76.2l-0.1-0.1C360.2,380.6,380.5,360.3,394.6,336
	L394.6,336z" />
      <path
        class="st5"
        d="M504,256h-88c0-88.3-71.7-160-160-160c-29.1,0-56.5,7.8-80,21.5v-0.1l-44-76.2v-0.1C168.5,20.1,210.8,8,256,8
	C393,8,504,119,504,256z" />
      <path
        d="M256,424c-92.6,0-168-75.4-168-168S163.4,88,256,88s168,75.4,168,168S348.6,424,256,424z M256,104c-83.8,0-152,68.2-152,152
	s68.2,152,152,152s152-68.2,152-152S339.8,104,256,104z" />
      <path
        d="M380,478.8c-2.8,0-5.5-1.4-6.9-4l-44-76.2c-2.2-3.8-0.9-8.7,2.9-10.9c3.8-2.2,8.7-0.9,10.9,2.9l44,76.2
	c2.2,3.8,0.9,8.7-2.9,10.9C382.7,478.4,381.4,478.8,380,478.8z" />
      <path
        d="M256,512C114.8,512,0,397.2,0,256S114.8,0,256,0s256,114.8,256,256S397.2,512,256,512z M256,16C123.7,16,16,123.7,16,256
	s107.7,240,240,240s240-107.7,240-240S388.3,16,256,16z" />
      <path d="M504,264h-88c-4.4,0-8-3.6-8-8s3.6-8,8-8h88c4.4,0,8,3.6,8,8C512,260.4,508.4,264,504,264z" />
      <path
        d="M41.2,388c-2.8,0-5.5-1.4-6.9-4c-2.2-3.8-0.9-8.7,2.9-10.9l76.2-44c3.8-2.2,8.7-0.9,10.9,2.9c2.2,3.8,0.9,8.7-2.9,10.9
	l-76.2,44C44,387.7,42.6,388,41.2,388z" />
      <path
        d="M176,125.4c-2.8,0-5.5-1.4-6.9-4l-44-76.2c-2.2-3.8-0.9-8.7,2.9-10.9c3.8-2.2,8.7-0.9,10.9,2.9l44,76.2
	c2.2,3.8,0.9,8.7-2.9,10.9C178.7,125.1,177.4,125.4,176,125.4z" />
      <path
        d="M470.8,388c-1.4,0-2.7-0.3-4-1.1l-76.2-44c-3.8-2.2-5.1-7.1-2.9-10.9s7.1-5.1,10.9-2.9l76.2,44c3.8,2.2,5.1,7.1,2.9,10.9
	C476.2,386.6,473.5,388,470.8,388z" />
      <path
        d="M256,336c-52.3,0-99.1-29.3-122.2-76.5c-1.1-2.2-1.1-4.8,0-7c23-47.2,69.8-76.5,122.2-76.5s99.1,29.3,122.2,76.5
	c1.1,2.2,1.1,4.8,0,7C355.1,306.7,308.3,336,256,336L256,336z M150,256c20.9,39.6,61.2,64,106,64s85.1-24.4,106-64
	c-20.9-39.6-61.2-64-106-64S170.9,216.4,150,256L150,256z" />
      <path
        d="M256,304c-26.5,0-48-21.5-48-48s21.5-48,48-48s48,21.5,48,48S282.5,304,256,304z M256,224c-17.6,0-32,14.4-32,32
	s14.4,32,32,32s32-14.4,32-32S273.6,224,256,224L256,224z" />
      <g>
        <path
          d="M647,400.1V127.9h95.4c33,0,58.1,6.3,75.2,19c17.1,12.7,25.6,31.2,25.6,55.6c0,13.3-3.4,25.1-10.3,35.3
		c-6.9,10.2-16.4,17.6-28.6,22.3c14,3.5,25,10.5,33,21.1c8,10.6,12.1,23.6,12.1,38.9c0,26.2-8.4,46-25.1,59.5
		c-16.7,13.5-40.5,20.3-71.4,20.6H647z M703.1,241.9h41.5c28.3-0.5,42.5-11.8,42.5-33.8c0-12.3-3.6-21.2-10.8-26.6
		c-7.2-5.4-18.5-8.1-33.9-8.1h-39.3V241.9z M703.1,281.6v73.5h48.1c13.2,0,23.5-3.1,31-9.4c7.4-6.3,11.1-15,11.1-26.1
		c0-24.9-12.9-37.6-38.7-38H703.1z" />
        <path d="M947.6,355.1h119.1v45.1H891.4V127.9h56.1V355.1z" />
        <path d="M1158.5,400.1h-56.1V127.9h56.1V400.1z" />
        <path
          d="M1424.2,309.4c-2.1,29.3-12.9,52.4-32.4,69.2c-19.5,16.8-45.2,25.2-77.1,25.2c-34.9,0-62.4-11.7-82.4-35.3
		c-20-23.5-30-55.8-30-96.8v-16.6c0-26.2,4.6-49.2,13.8-69.2c9.2-19.9,22.4-35.3,39.6-45.9c17.1-10.7,37.1-16,59.8-16
		c31.4,0,56.7,8.4,75.9,25.2c19.2,16.8,30.3,40.5,33.3,70.9h-56.1c-1.4-17.6-6.3-30.3-14.7-38.2c-8.4-7.9-21.2-11.9-38.4-11.9
		c-18.7,0-32.7,6.7-42,20.1c-9.3,13.4-14.1,34.2-14.3,62.4v20.6c0,29.4,4.5,50.9,13.4,64.5c8.9,13.6,23,20.4,42.2,20.4
		c17.3,0,30.3-4,38.8-11.9c8.5-7.9,13.4-20.2,14.7-36.7H1424.2z" />
        <path d="M1546.4,290.9l-29.2,31.4v77.8h-56.1V127.9h56.1v123.4l24.7-33.8l69.4-89.6h69l-96.7,121l99.5,151.3h-66.8L1546.4,290.9z" />
        <path d="M1760.3,355.1h119.1v45.1h-175.2V127.9h56.1V355.1z" />
        <path d="M1971.3,400.1h-56.1V127.9h56.1V400.1z" />
      </g>
    </svg>
  </div>
</template>

<script lang="ts" setup></script>

<style scoped>
.st0 {
  fill: #e6e9ed;
}

.st1 {
  fill: #ed7400;
}

.st2 {
  fill: #43938a;
}

.st3 {
  fill: #2f6569;
}

.st4 {
  fill: #f0bd70;
}

.st5 {
  fill: #43938a;
}

.st6 {
  fill: #f2a766;
}
</style>
